const stylesGlobal = {
  // display
  dGrid: {
    display: 'grid',
  },
  dBlock: {
    display: 'block',
  },
  dFlex: {
    display: 'flex',
  },
  dFlexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  flexOne: {
    flex: '1 1 0',
  },

  flexOneAndHalf: {
    flex: '1.5 1 0',
  },

  flexTwo: {
    flex: '2 1 0',
  },

  // align
  topLeft: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  bottomLeft: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
  },
  top: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bottom: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  topRight: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  bottomRight: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'flex-end',
  },
  between: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  // margin top
  mt60: {
    marginTop: 60,
  },
  mt16: {
    marginTop: 16,
  },
  mt8: {
    marginTop: 8,
  },
  mt24: {
    marginTop: 24,
  },
  mt40: {
    marginTop: 40,
  },

  // margin right
  mr16: {
    marginRight: 16,
  },
  mr8: {
    marginRight: 8,
  },

  // margin bottom
  mb24: {
    marginBottom: 24,
  },

  // margin left
  ml8: {
    marginLeft: 8,
  },

  // margin
  m0: {
    margin: 0,
  },
  mAuto: {
    margin: 'auto',
  },

  // padding
  p16: {
    padding: 16,
  },
  p0: {
    padding: 0,
  },
  pl0: {
    paddingLeft: 0,
  },
  pr0: {
    paddingRight: 0,
  },
  p24: {
    padding: 24,
  },

  // width
  w100: {
    width: '100%',
  },
  wAuto: {
    width: 'auto',
  },
  w16: {
    width: '16px',
  },
  w24: {
    width: '24px',
  },

  // height
  h100: {
    height: '100%',
  },

  // font
  f14: {
    fontSize: 14,
  },

  // color
  black: '#333333',
  white: '#ffffff',
  skyBlue: '#6eb8f6',
  lightBlue: '#438cf1',
  blue: '#3a83f9',
  darkBlue: '#0858d9',
  red: '#ff312e',
  green: '#2ecc71',
  grey: '#7b7b7b',
  lightgrey: '#adadad',
  altogrey: '#cecece',
  aquaBlue: '#ebf2fe',
  lighterRed: '#ffb6b5',
  blueDarker: '#053889',
  yellow: '#FABC2A',
  transparent: 'transparent',
  lightRed: '#ffeeee',
  lightGreen: '#cdffe2',

  // color accoding to https://www.2020colours.com/
  christmasSilver: '#e0e1e2',
  ghostWhite: '#f8fbff',
  culturedWhite: '#f5f5f5',
  chromeYellow: '#fdca40',
  genericGrey: '#9e9e9e',
  indigo: '#1b3c72',
  bDazzledBlue: '#285F90',
  lavenderBlue: '#BFD6FD',
  vividRed: '#E81310',
  trueBlue: '#0858D9',
  cosmicLatte: '#fef9eb',
  jordyBlue: '#89b5fb',

  // new color
  primary: '#3A83F9',
  primaryDark: '#2978AE',
  primaryLight: '#CEEBFF',
  primaryBackground: '#F9FBFF',
  lightMode: '#FFFFFF',
  neutral900: '#333333',
  neutral700: '#707070',
  neutral400: '#ADADAD',
  neutral200: ' #D6D6D6',
  neutral50: '#F5F5F5',
  neutral0: '#FFFFFF',
  red900: '#8E0C01',
  red700: '#DF1401',
  red500: '#FE6D61',
  red200: '#FEA29A',
  red50: '#FFECEB',
  green1200: '#10361F',
  green700: '#267D49',
  green500: '#36B368',
  green200: '#72CA95',
  green50: '#F5FBF7',
  yellow900: '#775403',
  yellow700: '#C78D05',
  yellow500: '#FABC2A',
  yellow200: '#FBD374',
  yellow50: '#FEF9EB',

  // card
  boxOptionBuySell: {
    borderRadius: 20,
    border: 'solid 1px #f5f5f5',
    backgroundColor: '#ffffff',
    padding: 8,
    marginRight: 0,
    alignItems: 'end',
    justifyContent: 'flex-end',
    display: 'flex',
  },

  // dropdown panel
  dropdown: {
    overflow: 'auto',
    width: 'auto',
    position: 'absolute',
    transform: 'translateY(55px)',
    top: 0,
    padding: 0,
    zIndex: 1000,
    borderRadius: 4,
    border: 'solid 1px #f5f5f5',
    backgroundColor: '#ffffff',
    boxShadow: '8px 2px 6px 0 rgba(51, 51, 51, 0.16)',
  },
  optionDropdown: {
    backgroundColor: 'transparent',
    padding: '8px 4px',
    cursor: 'pointer',
  },
  smallDropdown: {
    padding: '4px 8px',
    borderRadius: 4,
    border: 'solid 1px #f5f5f5',
    marginTop: 8,
  },
  buySellDropdown: {
    padding: '4px 8px',
    borderRadius: 4,
    border: 'solid 1px #f5f5f5',
  },

  // cursor
  pointer: {
    cursor: 'pointer',
  },

  // icon sort
  iconSort: {
    width: '16px',
    marginLeft: 8,
  },

  // spinner Input
  spinnerInput: {
    borderRadius: 0,
    boxShadow: 'none',
    border: 'none',
    textAlign: 'center',
    color: '#333333',
    fontSize: 15,
    width: 93,
  },

  // box shadow color
  boxShadow: {
    grey: '0 2px 8px 0 rgba(51, 51, 51, 0.08)',
    black: '0 3px 6px 0 rgba(0, 0, 0, 0.10)',
  },

  // hover action
  cardAction: {
    padding: 2,
    boxShadow: '0 4px 8px 0 rgba(51, 51, 51, 0.16)',
    border: 'solid 1px #f5f5f5',
    backgroundColor: '#ffffff',
    position: 'absolute',
    right: 16,
    top: -20,
    height: 40,
    display: 'flex',
    alignItems: 'center',
  },
};

export default stylesGlobal;
